import * as React from 'react';
import { ReactComponent as LikeIcon } from '../../../../../../assets/like-icon.svg';
import { ReactComponent as CommentIcon } from '../../../../../../assets/comment-icon.svg';

import { st, classes } from './ProGalleryHoverItem.st.css';

const IconAndText = ({ isLikeIcon, text, galleryHoverTextColor, isMedium }) => {
  return (
    <div className={st(classes.WarpIconAndText, { isMedium })}>
      {isLikeIcon ? (
        <LikeIcon fill={galleryHoverTextColor} stroke={galleryHoverTextColor} />
      ) : (
        <CommentIcon
          fill={galleryHoverTextColor}
          stroke={galleryHoverTextColor}
        />
      )}
      <div
        className={st(classes.Text, { isMedium })}
        style={{ color: galleryHoverTextColor }}
      >
        {text}
      </div>
    </div>
  );
};

export default IconAndText;
